<template>
  <v-dialog v-model="show" persistent max-width="400">
    <v-card>
      <v-card-title>Estimated cost</v-card-title>
      <v-divider/>
        <v-container class="pa-4">
          <v-row>
            <v-col>{{name}}</v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <date-picker v-model="date" label="As of date" @change="calculate"/>
            </v-col>
          </v-row>
          <template v-for="cost of costs">
            <v-row dense>
              <v-col cols="8" align="right">{{cost.name}}</v-col>
              <v-col cols="4" align="right">{{cost.value | currency}}</v-col>
            </v-row>
          </template>
          <v-row>
            <v-col cols="8" align="right"><strong>Total per case</strong></v-col>
            <v-col cols="4" align="right"><strong>{{total | currency}}</strong></v-col>
          </v-row>
          <v-row>
            <v-col cols="8" align="right"><strong>Total per bottle</strong></v-col>
            <v-col cols="4" align="right"><strong>{{total/caseSize | currency}}</strong></v-col>
          </v-row>
        </v-container>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="$emit('done')">Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {format} from 'date-fns'

export default {
  name: 'InventoryProductsEstimateCost',
  props: {
    productId: {type:String, required:true}
  },
  data() {
    return {
      show: true,
      name: '',
      date: format(new Date(), 'yyyy-MM-dd HH:mm:ss'),
      caseSize: 1,
      costs: []
    }
  },
  created() {
    this.calculate();
  },
  computed: {
    total() {
      return this.costs.reduce((total, cost) => total + cost.value, 0);
    }
  },
  methods: {
    async calculate() {
      const results = await this.$apiCall(`query InventoryProductsEstimateCost($productId:ID!, $date:DateTime!) {
                                             product(id:$productId) {
                                               name,estimatedCaseCost(date:$date) {name,value},caseSize
                                             }
                                           }`,
                                           {productId:this.productId, date:this.date});
      if (!results.error) {
        this.name = results.data.product.name;
        this.costs = results.data.product.estimatedCaseCost;
        this.caseSize = results.data.product.caseSize;
      }
    }
  }
}
</script>